export default __webpack_public_path__ + "static/media/texp3.b36f26a8.png";